
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum BcDocumentLineType {
	Comment = 0,
	Account = 1,
	Item = 2
}
export namespace BcDocumentLineType {
	export function getKeys(): Map<BcDocumentLineType, string> {
		return new Map([[0, 'Comment'], [1, 'Account'], [2, 'Item']]);
	}
}
